import { render, staticRenderFns } from "./blockPn.vue?vue&type=template&id=7a10c25a&scoped=true&"
import script from "./blockPn.vue?vue&type=script&lang=js&"
export * from "./blockPn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10c25a",
  null
  
)

export default component.exports